
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extract-images-from-xd",
      function () {
        return require("private-next-pages/extract-images-from-xd.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extract-images-from-xd"])
      });
    }
  